import React, { useContext } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';
import { Svg } from 'src/components/Svg/Svg';

import classes from './HeaderControls.scss';
import { HeaderContext } from './Header';

export const BasketIcon = React.memo(({ whiteIcons }: { whiteIcons: boolean }) => {
    const { cartPending, itemCount } = useContext(HeaderContext);
    return (
        <Link
            to="/basket"
            className={classnames(
                classes.headerControl,
                classes.headerControlBasket,
                'button--reset',
                'headerControlBasket',
            )}
        >
            <BasketWithCount pending={cartPending} count={itemCount} whiteIcons={whiteIcons} />
            <span className={classes.headerControlText}>Basket</span>
            <span className={classes.headerControlContent}>
                {itemCount > 0 ? (
                    <>
                        Basket
                        <small className={classes.headerControlMeta} data-test-id="BasketItemCount">
                            {cartPending ? '...' : itemCount}
                        </small>
                    </>
                ) : (
                    'Your basket is empty'
                )}
            </span>
        </Link>
    );
});

export const BasketWithCount: React.FC<{
    pending: boolean;
    count: number;
    variant?: 'inverted';
    whiteIcons?: boolean;
}> = ({ count, pending, whiteIcons }) => {
    return (
        <>
            <span className={classes.basketIcon}>
                <img
                    className={classes.basketCheckoutIcon}
                    src={
                        whiteIcons
                            ? require('../../../static/icons/cart-white.svg')
                            : require('../../../static/icons/cart.svg')
                    }
                    alt="checkout icon"
                />
            </span>
            <span
                className={classnames(classes.headerControlBasketCount, {
                    [classes.headerControlBasketCountInvert]: whiteIcons,
                })}
            >
                {pending ? '.' : count}
            </span>
        </>
    );
};
